/* ProductHomepageView.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { ApolloError } from '@apollo/client';
import { media } from '@atlaskit/primitives';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { FluidContainer, Meta, PartialOutageError } from '@atlassian/mpac-primitives';
import { CompatibleProductName } from '@atlassian/mpac-types';
import { ApolloErrorHandler } from '@atlassian/mpac-ui';
import { COMPATIBLE_PRODUCT_FILTER_VALUES } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { EnterpriseAppsSection } from '../components/EnterpriseAppsSection';
import { Hero } from '../components/Hero';
import { Sections } from '../components/Sections';
import { ErrorContainer } from '../Homepage/Homepage';
import { HeroWrapper, SectionWrapper } from '../HomepageCommon.styles';
import { useHomepage } from '../hooks';
import { useHomepageAnalytics } from '../hooks/useHomepageAnalytics';
import { setupProductHomepageTask } from '../telemetry/tasks';
import { useProductPageTelemetry } from '../telemetry/useProductPageTelemetry';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _13 = "@media (min-width:64rem) and (max-width:89.99rem){._1acz1gtx{padding:var(--_1bm102r)}}";
const _12 = "@media (min-width:48rem) and (max-width:63.99rem){._13zn1gtx{padding:var(--_1bm102r)}}";
const _11 = "@media not all and (min-width:48rem){._15txwcbu{padding:var(--_4thsry)}}";
const _10 = "._kqswh2mm{position:relative}";
const _9 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _8 = "._1yt4ojjz{padding:var(--_8gy4v2)}";
const _7 = "._1bah1h6o{justify-content:center}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._1wpz1fhb{align-self:stretch}";
const _4 = "._1bsb1osq{width:100%}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulpud5o{gap:.625rem}";
const HeroWrapperStyle = null;
const SectionWrapperStyle = null;

// eslint-disable-next-line max-lines-per-function
export const ProductHomepageView = _ref => {
  let {
    productInfo,
    productId
  } = _ref;
  const {
    enterpriseAppsSectionData,
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  } = useHomepage({
    productId,
    shouldFetchEnterpriseApps: !!productInfo.showEnterpriseAppsSection
  });
  const {
    trackTileRenders
  } = useHomepageAnalytics();
  const {
    heading,
    description,
    breadcrumbTitle,
    heroDesktopLeftImage,
    heroDesktopRightImage,
    heroMobileImage,
    heroTabletImage
  } = productInfo.banner;
  useProductPageTelemetry({
    productId,
    productInfo,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  });
  const productIdForAlgolia = COMPATIBLE_PRODUCT_FILTER_VALUES[productId];
  const productName = CompatibleProductName[productId];
  const showEnterpriseSection = !!productInfo.showEnterpriseAppsSection;
  const ProductPageTask = setupProductHomepageTask(showEnterpriseSection);
  useEffect(() => {
    if (!areSectionsLoading) {
      trackTileRenders(enterpriseAppsSectionData, sectionsData);
    }
  }, [enterpriseAppsSectionData, sectionsData]);
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (sectionsDataError && sectionsDataError instanceof ApolloError && (sectionsDataError === null || sectionsDataError === void 0 ? void 0 : sectionsDataError.message) !== 'SECTIONS_APPS_NOT_FOUND') {
    return /*#__PURE__*/_jsx(ApolloErrorHandler, {
      error: sectionsDataError,
      context: {
        page: 'ProductHomePage',
        operationName: 'GetMarketplaceProductHomePage'
      },
      renderError: () => {
        ProductPageTask.failed(sectionsDataError);
        return /*#__PURE__*/_jsx(ErrorContainer, {
          "data-testid": "error",
          children: /*#__PURE__*/_jsx(PartialOutageError, {
            level: "global"
          })
        });
      },
      nonServerErrorCallback: () => ProductPageTask.abort()
    });
  }
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Meta, {
        description: description,
        title: heading
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _3, _4, _5, _6, _7]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_zulpud5o _1e0c1txw _4cvr1h6o _1bsb1osq _1wpz1fhb _2lx21bp4 _1bah1h6o"]),
          children: /*#__PURE__*/_jsx(Hero, {
            heading: heading,
            description: description,
            breadcrumbTitle: breadcrumbTitle,
            productIdForAlgolia: productIdForAlgolia,
            productName: productName,
            heroDesktopLeftImage: heroDesktopLeftImage,
            heroDesktopRightImage: heroDesktopRightImage,
            heroTabletImage: heroTabletImage,
            heroMobileImage: heroMobileImage
          })
        })]
      }), /*#__PURE__*/_jsxs(FluidContainer, {
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_8, _9, _10, _2, _6, _5, _11, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            className: ax([enterpriseAppsSectionData && "_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
            style: {
              "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
              "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
              "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
            },
            children: /*#__PURE__*/_jsx(EnterpriseAppsSection, {
              isLoading: isEnterpriseAppsSectionLoading,
              isError: isEnterpriseAppsSectionLoadError,
              data: enterpriseAppsSectionData
            })
          })]
        }), !isEnterpriseAppsSectionLoading && /*#__PURE__*/_jsx(Sections, {
          isLoading: areSectionsLoading,
          isError: isSectionsLoadError,
          data: sectionsData,
          productId: productId
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Meta, {
      description: description,
      title: heading
    }), /*#__PURE__*/_jsx(HeroWrapper, {
      children: /*#__PURE__*/_jsx(Hero, {
        heading: heading,
        description: description,
        breadcrumbTitle: breadcrumbTitle,
        productIdForAlgolia: productIdForAlgolia,
        productName: productName
      })
    }), /*#__PURE__*/_jsxs(FluidContainer, {
      children: [/*#__PURE__*/_jsx(SectionWrapper, {
        children: /*#__PURE__*/_jsx(EnterpriseAppsSection, {
          isLoading: isEnterpriseAppsSectionLoading,
          isError: isEnterpriseAppsSectionLoadError,
          data: enterpriseAppsSectionData
        })
      }), !isEnterpriseAppsSectionLoading && /*#__PURE__*/_jsx(Sections, {
        isLoading: areSectionsLoading,
        isError: isSectionsLoadError,
        data: sectionsData,
        productId: productId
      })]
    })]
  });
};